import { render } from "./baseListView.vue?vue&type=template&id=680567bc"
import script from "./baseListView.vue?vue&type=script&lang=js"
export * from "./baseListView.vue?vue&type=script&lang=js"

import "./baseListView.vue?vue&type=style&index=0&id=680567bc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__